// extracted by mini-css-extract-plugin
export var deleteModal = "_gf-0";